import { lazy } from 'react';
import Loadable from 'components/Loadable';
import DefaultLayout from 'layout/Default';
import { ProtectedRoute } from 'routes/RouteGuards';

const ViewMovies = Loadable(lazy(() => import('views/movies/ViewMovies')));
const MovieForm = Loadable(lazy(() => import('views/movies/MovieForm')));
const ViewNextChange = Loadable(lazy(() => import('views/movies/ViewNextChange')));
const ViewComingSoon = Loadable(lazy(() => import('views/movies/ViewComingSoon')));

const MoviesRoutes = {
  path: '/movies',
  element: <ProtectedRoute />,
  children: [
    {
      element: <DefaultLayout />,
      children: [
        {
          index: true,
          element: <ViewMovies />
        },
        {
          path: 'add',
          element: <MovieForm />
        },
        {
          path: 'edit/:id/:purpose',
          element: <MovieForm />
        },
        {
          path: 'next-change',
          element: <ViewNextChange />
        },
        {
          path: 'coming-soon',
          element: <ViewComingSoon />
        }
      ]
    }
  ]
};

export default MoviesRoutes;
